import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  private drawer?: MatSidenav;

  setDrawer(drawer: MatSidenav) {
    this.drawer = drawer;
  }

  toggle() {
    if (this.drawer) {
      this.drawer.toggle();
    }
  }

  open() {
    if (this.drawer) {
      this.drawer.open();
    }
  }

  close() {
    if (this.drawer) {
      this.drawer.close();
    }
  }
}
